import { ComposeOperation } from '../store/schema/ComposeOperation';
import { ComposeViewState } from '../store/schema/ComposeViewState';

export default function isApprovalResponse(viewState: ComposeViewState): boolean {
    return (
        viewState.operation === ComposeOperation.Approve ||
        viewState.operation === ComposeOperation.Reject
    );
}
